import { queryOptions, useQuery } from "@tanstack/react-query"
import { GET } from "@/api/client"
import type { FinancialsWindow } from "@/api/types"

export function companyFinanceSummaryOptions(companyId: number) {
	return queryOptions({
		queryKey: ["companies", companyId, "finance-summary"],
		queryFn: () =>
			GET("/api/v1/companies/{company_id}/finance-summary", {
				params: { path: { company_id: companyId } },
			}),
		enabled: companyId > 0,
	})
}

export function useCompanyFinanceSummary(companyId: number, enabled = true) {
	return useQuery({
		...companyFinanceSummaryOptions(companyId),
		enabled: companyId > 0 && enabled,
	})
}

export function companyRevenueOptions(
	companyId: number,
	window: FinancialsWindow,
) {
	return queryOptions({
		queryKey: ["companies", companyId, "revenue", window],
		queryFn: () =>
			GET("/api/v1/companies/{company_id}/revenue", {
				params: {
					path: { company_id: companyId },
					query: { window },
				},
			}),
		enabled: companyId > 0,
	})
}

export function useCompanyRevenue(companyId: number, window: FinancialsWindow) {
	return useQuery(companyRevenueOptions(companyId, window))
}
